import React from 'react';
import BookTest from '../components/BookTest';

const Book = () => {
    return <BookTest />;
};

export default Book;